<template>
    <EditingDialog
        :context="context"
        :showSnackbar="true"
        snackbarTextLangConst="lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON"
        :useDifferentShowDialogProp="true"
    >
        <template v-slot:editForm>
            <v-container fluid>
                <!-- 1st row : select name and type -->
                <v-row>
                    <v-col>
                        <BaseEditPageDropdown 
                            :context="context"
                            field="Type"
                            :items="typeOptions" 
                            :label="$t('lang_GENERIC_CAPTION_TYPE')" 
                            :alvqa="alvqa + '-dropdown-type'"
                            rules="required"
                            :clearable="false"
                            :withMargin="false"
                            :additionalFunction="autoFillIdByType"
                        />
                    </v-col>
                    <v-col>
                        <BaseEditPageAutocomplete 
                            :context="context"
                            field="PersonObject"
                            :label="$t('lang_AZ_PERSONS_CAPTION_NAME')"
                            rules="required"
                            :withFreeText="false"
                            :withMargin="false"
                            :alvqa="alvqa + '-autocomplete-name'"
                            :additionalFunction="fillInName"
                            item-value="alvId"
                            v-if="getType !== 'recipientId'"
                        >
                            <template v-slot:selection="{ item }">
                                <div 
                                    class="ellipsis" 
                                    :alvqa="alvqa + '-autocomplete-name-selection'" 
                                >
                                    {{ $alvPlugin.getOtherIdsRoleLabel(item) }}
                                </div>
                            </template>
                            <template v-slot:items="{ items }">
                                <v-list-item-content :alvqa="alvqa + '-autocomplete-name-dropdown-' + items.alvId">
                                    <v-list-item-title :alvqa="alvqa + '-autocomplete-name-dropdown-' + items.alvId + '-title'">
                                        {{ $alvPlugin.getOtherIdsRoleLabel(items) }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle :alvqa="alvqa + '-autocomplete-name-dropdown-' + items.alvId + '-subtitle'">
                                        {{ items.alvId }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </template>
                        </BaseEditPageAutocomplete>
                        <BaseEditPageTextField 
                            field="Name"
                            :label="$t('lang_AZ_PERSONS_CAPTION_NAME')"
                            :context="context"
                            :clearable="false"
                            :withMargin="false"
                            :disabled="true"
                            :alvqa="alvqa + '-textfield-name'"
                            v-else
                        />
                    </v-col>
                </v-row>

                <!-- 2nd row : source and value -->
                <v-row>
                    <v-col>
                        <BaseEditPageDropdown 
                            :context="context"
                            field="SourceAlvId"
                            :items="sourceOptions" 
                            :label="$t('lang_GENERIC_CAPTION_SOURCE')" 
                            :alvqa="alvqa + '-dropdown-source'"
                            :withMargin="false"
                            :rules="getType === 'recipientId' ? 'required' : ''"
                            :disabled="getType !== 'recipientId'"
                            :additionalFunction="fillInSource"
                        />
                    </v-col>
                    <v-col>
                        <BaseEditPageTextField
                            :context="context"
                            field="Value"
                            :label="$t('lang_GENERIC_CAPTION_ID')"
                            :alvqa="alvqa + '-textfield-id'"
                            :withMargin="false"
                            :rules="getType === 'recipientId' ? 'required' : ''"
                            :disabled="getType !== 'recipientId'"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </EditingDialog>
</template>

<script>
import EditingDialog from '@/components/_dialogs/EditingDialog'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageAutocomplete from '@/components/_editForm/BaseEditPageAutocomplete'
import { DropdownAzPersonsOtherIdsTypes } from '@/assets/dropdowns/alvDropdowns.js'


export default {
    name: "OtherIdsEditDialog",
    components: {
        EditingDialog,
        BaseEditPageDropdown,
        BaseEditPageTextField,
        BaseEditPageAutocomplete,
    },
    data() {
        return {
            context: "AzPersonsOtherIds",
            alvqa: "az-persons-edit-form-other-ids-dialog",
            typeOptions: DropdownAzPersonsOtherIdsTypes,
        }
    },
    computed: {
        getType() {
            return this.$store.getters.getAzPersonsOtherIdsDetailsType
        },
        getAlvIdPerson() {
            return this.$store.getters.getAzPersonsOtherIdsDetailsAlvId
        },
        getSelectedPersonName() {
            return this.$store.getters.getAzPersonsOtherIdsDetailsName
        },
        sourceOptions() {
            if (this.getType == 'recipientId') {
                return this.$store.getters.getAzForMappingsImport;
            }

            let list = [
                {
                    value: null,
                    text: "ALV",
                    alvqa: this.alvqa + '-dropdown-source-item-alv'
                }
            ]
            
            return list;
        },
        getSelectedPersonObject() {
            return this.$store.getters.getAzPersonsOtherIdsDetailsPersonObject
        },

    },
    methods: {
        fillInName (person) {
            if (person !== null && typeof person == 'object') {
                this.$store.commit('setAzPersonsOtherIdsDetailsName', person.gemaName)
                this.$store.commit('setAzPersonsOtherIdsDetailsAlvId', person.alvId)
                this.$store.commit('setAzPersonsOtherIdsDetailsSlgContractId', person.slgContractId || null)
                this.$store.commit('setAzPersonsOtherIdsDetailsSlgSubcatalogId', person.slgSubcatalogId || null)
                if (this.getType !== 'recipientId') {
                    this.$store.commit('setAzPersonsOtherIdsDetailsValue', person.alvId)
                }
            } else {
                this.$store.commit('setAzPersonsOtherIdsDetailsSlgContractId', null)
                this.$store.commit('setAzPersonsOtherIdsDetailsSlgSubcatalogId', null)
            }
        },
        fillInSource (source) {
            let sourceObj = this.sourceOptions.find((item) => item.value == source)
            this.$store.commit('setAzPersonsOtherIdsDetailsSource', sourceObj ? sourceObj.text : null)
        },
        autoFillIdByType (type) {
            this.$store.commit('setAzPersonsOtherIdsDetailsSourceAlvId', null)
            if (type !== 'recipientId') {
                this.$store.commit('setAzPersonsOtherIdsDetailsValue', this.getAlvIdPerson)
                this.$store.commit('setAzPersonsOtherIdsDetailsSource', null)
            } else {
                this.$store.commit('setAzPersonsOtherIdsDetailsValue', null)
                this.$store.commit('setAzPersonsOtherIdsDetailsName', '')
                this.$store.commit('setAzPersonsOtherIdsDetailsAlvId', null)
                this.$store.commit('setAzPersonsOtherIdsDetailsSlgContractId', null)
                this.$store.commit('setAzPersonsOtherIdsDetailsSlgSubcatalogId', null)
            }
        }
    },
    created() {
        this.$store.dispatch("fetchAzForMappings");
    },
}
</script>
